import jsonExport from "jsonexport/dist";
import { downloadCSV } from "react-admin";
import get from "lodash/get";
const exporter = (data, headers, title) => {
  const BOM = "\uFEFF";

  const exportData = headers
    ? data.map((record) => {
        const newRecord = {};
        headers.map((header) => {
          const { source, label } = header;
          newRecord[label] = get(record, source, "");
          switch (source) {
            case "payment_channels":
              newRecord[label] = newRecord[label]
                .map((channel) => channel.type)
                .join(", ");
              break;
            default:
              break;
          }
          return header;
        })
        return newRecord;
      })
    : data;

  jsonExport(exportData, { headers: [] }, (_, csv) => {
    downloadCSV(
      `${BOM}${title ? title + "\n" : ""}${csv}`,
      (title ?? "data") + " report"
    ); // download as 'posts.csv` file
  });
};

export default exporter;
